import React from "react";
import dayjs from "dayjs";
import { ClassificationMethodLabels, FpbSummary } from "../../../../models/vod/Models";
import BadgeList from "./BadgeList";

interface Props {
    fpbSummary: FpbSummary;
}

const VODFpbSummaryView = ({ fpbSummary }: Props) => {

    const valueOrEmpty = (value? : string | number | null, type: string = "text" ) => {
        let element = <p>{value}</p>;

        if (type === "link")
            element = (
                <a href={value as string} target={"_blank"} rel="noreferrer">{value}</a>
            );
        return value ?
            element
            : <p className = {"tracking-[-0.15em] text-gray-400"}>{"———"}</p>;
    };

    const dateTimeOrEmpty = ( value : string | number | Date | dayjs.Dayjs | null | undefined, format: string) => {
        const date = value ? dayjs(value).format(format) : null;

        return valueOrEmpty(date);
    };

    const durationOrEmpty = ( value : string | null | undefined, format: string) => {
        const date = value ? dayjs.duration(value).format(format) : null;

        return valueOrEmpty(date);
    };

    if (!fpbSummary)
        return <></>;

    return (
      <>
        <div className={`border-b border-b-brand-500/10 dark:border-b-white/10 pb-4`}>
            <div className={"grid grid-cols-2 gap-y-4"}>
                <div className = {"flex flex-col gap-1 col-span-2"}>
                    <p className = {`font-bold`}>Title</p>
                    {valueOrEmpty(fpbSummary.title)}
                </div>
                <div className = {"flex flex-col gap-1"}>
                    <p className={`font-bold`}>Content Partner Id</p>
                    {valueOrEmpty(fpbSummary.contentPartnerId)}
                </div>
                <div className = {"flex flex-col gap-1"}>
                    <p className={`font-bold`}>Content Partner Name</p>
                    {valueOrEmpty(fpbSummary.contentPartnerName)}
                </div>
                <div className = {"flex flex-col gap-1"}>
                    <p className = {`font-bold`}>Certificate Reference Number</p>
                    {valueOrEmpty(fpbSummary.certificateReferenceNumber)}
                </div>
                <div className = {"flex flex-col gap-1"}>
                    <p className = {`font-bold`}>Classification Method</p>
                    {valueOrEmpty(fpbSummary.classificationMethod ? ClassificationMethodLabels[fpbSummary.classificationMethod] : "")}
                </div>
                <div className = {"flex flex-col gap-1"}>
                    <p className = {`font-bold`}>Classification Issue Date</p>
                    {dateTimeOrEmpty(fpbSummary.classificationIssueDate, "DD MMM YYYY")}
                </div>
                {
                    (!fpbSummary.certificateLocation || typeof fpbSummary.certificateLocation === "string") &&
                    <div className = {"flex flex-col gap-1"}>
                        <p className = {`font-bold`}>Certificate Location</p>
                        {valueOrEmpty(fpbSummary.certificateLocation, "link")}
                    </div>

                }
            </div>
        </div>
        <div className={`border-b border-b-brand-500/10 dark:border-b-white/10 py-4`}>
            <div className={"grid grid-cols-2 gap-y-4"}>
                <div className = {"flex flex-col gap-1"}>
                    <p className={`font-bold`}>Age Rating</p>
                    {valueOrEmpty(fpbSummary.ageRating)}
                </div>
                <div className = {"flex flex-col gap-1"}>
                    <p className = {`font-bold`}>Runtime</p>
                    {durationOrEmpty(fpbSummary.runTime, "HH:mm:ss")}
                </div>
                {
                    fpbSummary.itemType !== "BOX_SET" &&
                    fpbSummary.itemType !== "SERIES" &&
                    fpbSummary.itemType !== "STANDALONE" &&
                    <div className = {"flex flex-col gap-1"}>
                        <p className = {`font-bold`}>Season Number and Episode Number (Item Code)</p>
                        {valueOrEmpty(fpbSummary.seasonNumberAndEpisodeNumber)}
                    </div>
                }
                <div className={"flex flex-col gap-1 col-span-2"}>
                    <p className = {`font-bold`}>Categories</p>
                    <BadgeList items={fpbSummary.categories}/>
                </div>
                <div className={"flex flex-col gap-1 col-span-2"}>
                    <p className = {`font-bold`}>Advisories</p>
                    <BadgeList items={fpbSummary.advisories}/>
                </div>
                <div className={"flex flex-col gap-1 col-span-2"}>
                    <p className={`font-bold`}>Licensing window</p>
                    <div className={"grid grid-cols-2 gap-y-1"}>
                        <div className={"flex flex-col gap-1"}>
                            <p className={`font-bold`}>Start</p>
                            {dateTimeOrEmpty(fpbSummary.licensingWindow?.startDateTime, "DD MMM YYYY [@] HH:mm")}
                        </div>
                        <div className={"flex flex-col gap-1"}>
                            <p className={`font-bold`}>End</p>
                            {dateTimeOrEmpty(fpbSummary.licensingWindow?.endDateTime, "DD MMM YYYY [@] HH:mm")}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className={`gap-y-4 py-4 grid grid-cols-2`}>
            <div className={`flex flex-col gap-1`}>
                <p className={`font-bold`}>Created</p>
                {dateTimeOrEmpty(fpbSummary.createdDateTime, "DD MMM YYYY [@] HH:mm")}
            </div>
            <div className={`flex flex-col gap-1`}>
                <p className={`font-bold`}>Last Modified</p>
                {dateTimeOrEmpty(fpbSummary.lastModifiedDateTime, "DD MMM YYYY [@] HH:mm")}
            </div>
            <div className={`flex flex-col gap-1`}>
                <p className={`font-bold`}>Version</p>
                { fpbSummary.version && <p className = {`font-bold`}>{fpbSummary.version}</p> }
            </div>
        </div>
      </>
    );

};

export default VODFpbSummaryView;